import React, { useEffect, useRef, useState } from 'react';
import localeLookup from '../config/locale';
import Icon from './Icon';
import cx from 'classnames';

const NetworkInfo = () => {
  const [visible, setVisible] = useState(false);
  const [online, setOnline] = useState(true);
  const timerRef = useRef(null);

  const onlineHandler = () => {
    setOnline(true);
    timerRef.current = setTimeout(() => {
      setVisible(false);
    }, 5000);
  };

  const offlineHandler = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    setOnline(false);
    setVisible(true);
  };

  useEffect(() => {
    window.addEventListener('online', onlineHandler);
    window.addEventListener('offline', offlineHandler);

    return () => {
      window.removeEventListener('online', onlineHandler);
      window.removeEventListener('offline', offlineHandler);
    };
  }, []);

  return (
    <div
      className={cx('network-info', {
        'network-info--color-red': !online,
        'network-info--color-green': online,
        'network-info--visible': visible,
      })}
    >
      <Icon color="white" kind={online ? 'wifi' : 'wifi-blocked'}></Icon>
      <p>
        {online
          ? localeLookup('translations.Connection restored')
          : localeLookup('translations.No internet connection')}
      </p>
    </div>
  );
};

export default NetworkInfo;
